// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import ReactTooltip, { Place, Type } from 'react-tooltip'; // eslint-disable-line no-unused-vars

/** @typedef {{
  id: string,
  place?: Place,
  type?: Type,
  renderTooltip: () => JSX.Element | string | null,
  children: React.ReactNode
}} TooltipPropsType */

/** @type { StatelessComponent<TooltipPropsType> } */
const Tooltip = ({ id, place = 'top', type = 'info', renderTooltip, children }) => (
  <span>
    <span data-tip data-for={`tooltip-${id}`}>
      {children}
    </span>
    <ReactTooltip id={`tooltip-${id}`} place={place} type={type} effect="solid">
      {renderTooltip()}
    </ReactTooltip>
  </span>
);

export default Tooltip;
